const STORAGE_KEY = 'zeres-general-info'

export const readGeneralInfo = (): Record<string, string> => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved == null) {
      return {}
    }
    const parsed: unknown = JSON.parse(saved)
    if (
      parsed != null &&
      typeof parsed === 'object' &&
      !Array.isArray(parsed)
    ) {
      return parsed as Record<string, string>
    }
  } catch {
    // ignore malformed storage and fall back to empty object
  }

  return {}
}

export const writeGeneralInfo = (values: Record<string, string>): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(values))
}

export const isGeneralInfoComplete = (): boolean => {
  const parsed = readGeneralInfo()
  return [
    'firstName',
    'lastName',
    'street',
    'postalCode',
    'city',
    'phone',
    'accountHolder',
    'iban'
  ].every((field) => (parsed[field] ?? '').trim().length > 0)
}
